import { useAppSelector } from "../../app";
import { GroupBlockEntityType } from "../../configMap";
import selectAnnotationReducer from "../../annotation/selectors/annotationReducerSelector";

const useIsEntityRequiredEmpty = (
  groupBlockEntityType: GroupBlockEntityType,
  groupBlockIndex: number,
): boolean => {
  const incompleteEntities = useAppSelector(
    (state) => state.metadataReducer.incompleteEntities,
  );

  const annotations = useAppSelector(selectAnnotationReducer);

  const isFlaggedAsIncomplete = incompleteEntities.some(
    (be) =>
      be.entityTypeId === groupBlockEntityType.entityType.id &&
      be.index === groupBlockIndex,
  );

  if (!isFlaggedAsIncomplete) {
    return false;
  }

  const hasAnnotation = annotations.some(
    (annotation) =>
      annotation.entity?.id === groupBlockEntityType.entityType.id &&
      annotation.index === groupBlockIndex &&
      !annotation.tempAnnotation,
  );

  return !hasAnnotation;
};

export default useIsEntityRequiredEmpty;
